module.exports = __webpack_public_path__ + "static/img/hands_raised.b977790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/hands_raised.png
// module id = FdnQ
// module chunks = 6